export default {
  Normal: 'Normal',
  Turbo: 'Turbo',
  Lightning: 'Lightning',
};
